<script setup lang="ts">
import type { Row } from '@tanstack/vue-table'
import type { HTMLAttributes } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'
import { cn } from '#ui-kit/lib/utils'
import { Button } from '#ui-kit/ui/button'

type ExpandableRow = Pick<Row<unknown>, 'getIsExpanded' | 'toggleExpanded'>

const props = defineProps<{
  row: ExpandableRow
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn('flex items-center justify-center', props.class)">
    <Button
      variant="ghost"
      size="xs"
      icon-only
      :aria-expanded="row.getIsExpanded()"
      :aria-label="row.getIsExpanded() ? 'Collapse row' : 'Expand row'"
      @click="row.toggleExpanded()"
    >
      <ChevronDownIcon
        class="transition-transform duration-200"
        :class="{ 'rotate-180': row.getIsExpanded() }"
        aria-hidden="true"
      />
    </Button>
  </div>
</template>
